<template>
  <div class="tw-flex tw-h-[fit-content]">
    <span
      v-for="(avatar, index) in [...avatars].splice(0, maxShown)"
      :key="index"
      :class="`tw-border-[0.938px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-[468.75px] tw-w-[32px] tw-inline-block tw-aspect-square tw-overflow-hidden tw-ml-[-4px]`"
      @mouseover="emit('on:hover', avatar)"
      @mouseout="emit('on:hover', {})"
    >
      <img
        v-if="avatar.file"
        :src="avatar.file ? `data:image/png;base64,${avatar.file}` : ''"
        :alt="`avatar${index + 1}`"
        class="tw-w-full tw-h-full"
      />
      <GlobalAvatar
        v-if="avatar.file === null"
        class="tw-cursor-pointer"
        :name="avatar?.userName"
        :class-name="'user-icon'"
      />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { IUserProfileImage } from "@/interfaces/userInterfaces";
import { PropType } from "vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
const emit = defineEmits(["on:hover"]);
defineProps({
  avatars: { type: Array as PropType<IUserProfileImage[]>, default: () => [] },
  maxShown: { type: Number, default: 2 },
});
</script>
